import { lazy } from 'react';

// project import
import GuestGuard from 'utils/route-guard/GuestGuard';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/auth/login')));
const AuthRegister = Loadable(lazy(() => import('pages/auth/register')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/auth/forgot-password')));
const AuthCheckMail = Loadable(lazy(() => import('pages/auth/check-mail')));
const AuthResetPassword = Loadable(lazy(() => import('pages/auth/reset-password')));
const AuthCodeVerification = Loadable(lazy(() => import('pages/auth/code-verification')));
const AuthSelections = Loadable(lazy(() => import('pages/auth/selections')));
const CheckLoginGoogle = Loadable(lazy(() => import('pages/auth/checkLoginGoogle')));
const AuthVerifys = Loadable(lazy(() => import('pages/auth/verifys')));
const PDPA = Loadable(lazy(() => import('pages/auth/PDPA')));
// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <GuestGuard>
          <CommonLayout />
        </GuestGuard>
      ),
      children: [
        {
          path: '/',
          element: <AuthSelections />
        },
        {
          path: 'login',
          element: <AuthLogin />
        },
        {
          path: 'verify/:id?',
          element: <AuthVerifys />
        },
        {
          path: 'checklogingoogle/:CitizenID/:UnitID',
          element: <CheckLoginGoogle />
        },
        {
          path: 'pdpa/:CitizenID/:UnitID/:id?',
          element: <PDPA />
        },
        {
          path: 'register',
          element: <AuthRegister />
        },
        {
          path: 'forgot-password',
          element: <AuthForgotPassword />
        },
        {
          path: 'check-mail',
          element: <AuthCheckMail />
        },
        {
          path: 'reset-password',
          element: <AuthResetPassword />
        },
        {
          path: 'code-verification',
          element: <AuthCodeVerification />
        }
      ]
    }
  ]
};

export default LoginRoutes;
